import React, { useEffect, useState } from "react";
// import axios from 'axios';
// import ParseDBFHeader from "./ParseDBFHeader";
import _ from 'lodash';
import DatePicker from "react-datepicker";
import ReactFileReader from 'react-file-reader';
import { Link } from "react-router-dom";
import { DateInputFormat } from "../common/DateComponents";
/*import { PDFDownloadLink, Document, Page, View, Text } from '@react-pdf/renderer'
import { 
  Table,
  TableHeader,
  TableCell,
  TableBody,
  DataTableCell,
} from '@david.kucsai/react-pdf-table'*/
import { addMonths, format, isValid } from 'date-fns';


import { connect } from 'react-redux';
import { Actions as DEPUTY_ACTIONS } from '../integrations/deputy/store/deputyActions';
import { Actions as EMPLOYEE_ACTIONS } from '../../store/actions/employeeActions';
import { Actions as LEAVE_ACTIONS } from '../../store/actions/leaveActions';
import { Actions as PAYROLL_ACTIONS } from '../../store/actions/payrollActions';
import { Actions as TIMESHEET_IMPORT_ACTIONS } from '../../store/actions/timesheetImportActions';

import { NotificationManager } from "react-notifications";
import { ArrowDownTrayIcon, CheckCircleIcon, ClipboardDocumentCheckIcon, ExclamationCircleIcon, WrenchScrewdriverIcon, ExclamationTriangleIcon } from "@heroicons/react/20/solid";
import { ArrowUpTrayIcon } from "@/icons/outline";
import Spinner from "../common/Spinner";
import DeputyImport from '../integrations/deputy/DeputyImport';
import ImportWarnings from './timesheet-import/ImportWarnings';
import TimesheetFieldMapping from './timesheet-import/TimesheetFieldMapping';
import {
  preview
} from './timesheet-import/timesheetImportHelpers';
import TimesheetTemplateModal from "./TimesheetTemplateModal";
import IntegrationTimesheetImport from "../integrations/IntegrationTimesheetImport";
import { convertDate } from "./timesheet-import/timesheetImportHelpers";

import apiURL from'../../store/actions/apiURL';


const TimesheetImport = ({

  // data
  employees,
  employeesByReference,
  lastPayPeriod,
  deputyConnected,
  deputyNeedsReconnection,
  company,

  // leave data
  leaveFrom,
  leaveTo,
  leave,
  leaveUpdating,
  leaveUpdated,

  //timesheet import data
  // ignore,
  fieldMapping,
  filename,
  processingFile,
  fields,
  data,
  dataToSend,
  importStatus,
  hasWarnings,
  warningsGenerated,
  processingWarnings,
  importFrom,
  importTo,
  timesheetImportGetMapping,
  payrollGetLastPayPeriod,
  employeesGetListWithSalary,
  isConnectedWithDeputy,
  leaveGet,
  handleTimesheetImportFiles,
  handleTimesheetPhotoImport,
  setTimesheetTemplateModalOpen,
  processWarnings,
  showMappingSettings,
  setShowMapping,
  prepareTimesheetImportForProcessing,
  setImportDates,
  sendTimesheetData,
  timeAttendanceIntegration,
  timesheetInvalidDateError,
  timesheetImportInvalidDate,
  clearTimesheetImportData,
}) => {


  const [ignorePeriodWarning, setIgnorePeriodWarning] = useState(false);
  // const [processing, setProcessing] = useState(false);

  const [minDate, setMinDate] = useState();
  const [maxDate, setMaxDate] = useState();
  const [loaded, setLoaded] = useState(false);
  // const [startDate, setStartDate] = useState();
  // const [endDate, setEndDate] = useState();

  // const [prevFields, setPrevFields] = useState(false);
  // const [importWarnings, setImportWarnings] = useState(false);
  // const [employeeNotFound, setEmployeeNotFound] = useState(false);

  useEffect(() => {
    setLoaded(employeesByReference && (typeof (lastPayPeriod) == 'boolean' || lastPayPeriod));
  }, [lastPayPeriod, Object.keys(employeesByReference).length]);

  // const showSettings = !fieldMapping;


  useEffect(() => {

    if (fieldMapping && data && Object.keys(fieldMapping).length > 0 && data.length > 0) {
      const dateKey = getKeyByValue(fieldMapping, 'date');

      if (!dateKey) return

      const maxDateRow = _.maxBy(data, (i) => convertDate(i?.[dateKey]));
      const minDateRow = _.minBy(data, (i) => convertDate(i?.[dateKey]));

      // console.log('dateKey',dateKey,maxDateRow,minDateRow)

      setIgnorePeriodWarning(false)
      const minDateString = preview(dateKey, fieldMapping, minDateRow);
      const maxDateString = preview(dateKey, fieldMapping, maxDateRow);

      if (isValid(new Date(minDateString)) == false || isValid(new Date(maxDateString)) == false){
        const invalidDate = isValid(new Date(minDateString)) ? maxDateString : minDateString;
        timesheetImportInvalidDate();
        clearTimesheetImportData();
        NotificationManager.error(`Invalid date format - Cannot parse ${invalidDate}`, 'Error', 5000);
        return;
      };

      if (dateKey && minDateString && maxDateString) {

        const convertedMinDate = format(new Date(convertDate(minDateString)),"yyyy-MM-dd")
        const convertedMaxDate = format(new Date(convertDate(maxDateString)),"yyyy-MM-dd")

        setMinDate(new Date(convertedMinDate))
        setMaxDate(new Date(convertedMaxDate))

        setImportDates({
          from: new Date(convertedMinDate),
          to: new Date(convertedMaxDate)
        })

        // refresh employee data with period to get correct departments
        employeesGetListWithSalary({
          from: convertedMinDate,
          to: convertedMaxDate,
        })
      }
    }

  }, [JSON.stringify(fieldMapping), JSON.stringify(data || [])]);

  useEffect(() => {
    console.log('starting to obtain Data')

    if (!loaded) {
      // set loaded right away to avoid a re-trigger

      timesheetImportGetMapping()
      payrollGetLastPayPeriod()
      employeesGetListWithSalary({
        from: format(addMonths(new Date(), -1), 'yyyy-MM-01'),
        to: format(addMonths(new Date(), 3), 'yyyy-MM-31')
      })
      isConnectedWithDeputy();

    }
  }, []);

  useEffect(() => {

    if (dataToSend && leaveUpdated && !leaveUpdating && !warningsGenerated) {

      console.log('processWarnings start')
      processWarnings()

    }
  }, [leaveUpdated, dataToSend && JSON.stringify(dataToSend).length]);

  // console.log('connected',connected,connectLink)

  if (!loaded) {
    return (
      <div>
        We're loading your settings. Hold on...
      </div>
    )
  }

  const getKeyByValue = (object, value) => {
    return Object.keys(object).find(key => object[key] === value);
  }

  const importTimesheetData = async (e) => {
    e.preventDefault();
    if (processingFile) return;

    //get leave

    // check if 
    leaveGet({
      from: format(new Date(importFrom), "yyyy-MM-dd"),
      to: format(new Date(importTo), "yyyy-MM-dd"),
      status: "Approved"
    });

    // TODO if these are punches we may need other pre-processing
    prepareTimesheetImportForProcessing()
  }

  const handlePhotoImport = (file) => {
    handleTimesheetPhotoImport(file[0], company);
  }

  if (deputyNeedsReconnection || deputyConnected || timeAttendanceIntegration) return (
    <IntegrationTimesheetImport />
  )

  const showImportWarning = !ignorePeriodWarning && minDate && lastPayPeriod && lastPayPeriod.periodEnd && lastPayPeriod.periodEnd >= format(minDate, "yyyy-MM-dd")

  return (

    <div>
				<div
					className="col-xs-12 pl-0"
					style={{ paddingBottom: "3rem", paddingTop: "3rem" }}
				>
					<div className="pull-left">
						<h5>Import Timesheets</h5>
					</div>
				</div>


      <div className='btn btn-default' style={{ marginLeft: 10, marginRight: 10 }}>
        <ReactFileReader fileTypes={[".csv", ".dbf", ".*", "application/dbase", "application/dbf"]} handleFiles={handleTimesheetImportFiles}>
          <ArrowUpTrayIcon style={{ height: "1.5em", float: "left", marginRight: 5 }} />
          <div style={{ float: "left" }}>Upload CSV Timesheet File</div>
        </ReactFileReader>
      </div>

      <div className='btn btn-default' style={{ marginRight: 10 }}>
        <ReactFileReader fileTypes={[".jpg", ".jpeg"]} handleFiles={handlePhotoImport}>
          <ArrowUpTrayIcon style={{ height: "1.5em", float: "left", marginRight: 5 }} />
          <div style={{ float: "left" }}>Upload Timesheet Photo</div>
        </ReactFileReader>
      </div>

      <div className='btn btn-default pull-right' style={{ marginRight: 10 }} onClick={() => setTimesheetTemplateModalOpen()}>
        <ArrowDownTrayIcon style={{ height: "1.5em", float: "left", marginRight: 5 }} />
        <div style={{ float: "left" }}>Download Timesheet Template</div>
      </div>

      {timesheetInvalidDateError &&
        <div className="alert alert-warning clearfix" style={{color:'#232a32', marginTop: 15 }}>
        <ExclamationTriangleIcon className="media-middle" style={{minWidth:"2.25rem",width:"2.25rem", verticalAlign: "top", marginRight: "10px"}}/>
        Dates have invalid time values when utilising your local browser settings.
        <a 
        style={{
          paddingLeft: '0.3rem',
          paddingRight: '0.3rem'
          }}
          target="_blank"
          href="https://support.buddy.hr/hc/en-mt/articles/360021529080-Uploading-Timesheets-by-csv"
          >
          Click here
          </a>
            to find a solution.
        </div>
      }

      {
        fields && data && data[0] && (showMappingSettings || !fieldMapping) &&
        <TimesheetFieldMapping />
      }

      {
        fields && data && !(showMappingSettings || !fieldMapping) &&
        <div className='btn btn-success' onClick={() => { setShowMapping(true) }}>
          <WrenchScrewdriverIcon style={{ height: "1.5em", float: "left", marginRight: 5 }} />
          <div style={{ float: "left" }}>View/Edit Import Settings</div>
        </div>
      }

      {
        data && !(showMappingSettings || !fieldMapping) && (!dataToSend || processingWarnings) &&
        <React.Fragment>

          {showImportWarning &&

            <div className="alert alert-warning clearfix" style={{ color: '#232a32' }}>
              <ExclamationCircleIcon style={{ height: "1.5em", float: "left", marginRight: 5 }} />
              Payroll has been already closed for the period ending {format(new Date(lastPayPeriod.periodEnd), "do MMM yyyy")}.
              Importing timesheets that relate to this period, will make these hours payable in the next payroll.
              Proceeding may result in paying employees more than once for the same hours.

              <span
                className={`btn btn-warning pull-right`}
                style={{ minWidth: "230px", maxWidth: "230px", marginLeft: "10px" }}
                onClick={() => {
                  setIgnorePeriodWarning(true)
                }}>
                I understand. Continue to Import
              </span>
            </div>
          }
          {!showImportWarning &&
            <div className="form-group" style={{ marginTop: 20 }}>
              <div className="col-sm-3">
                <label>From</label>
                <DatePicker
                  selected={importFrom}
                  onChange={(date) => setImportDates({ from: date })}
                  minDate={minDate}
                  maxDate={maxDate}
                  dateFormat="dd/MM/yyyy"
                  customInput={<DateInputFormat />}
                />
                {/*<input id="date" type="text" className="form-control remove_error" name="date" />*/}
                <div className="clearfix" />
              </div>
              <div className="col-sm-3">
                <label htmlFor=" ">To</label>
                <DatePicker
                  selected={importTo}
                  onChange={(date) => setImportDates({ to: date })}
                  maxDate={maxDate}
                  minDate={minDate}
                  dateFormat="dd/MM/yyyy"
                  customInput={<DateInputFormat />}
                />
                <div className="clearfix" />
              </div>

              <div
                className="btn btn-success pull-right"
                style={{ marginRight: 10 }}
                onClick={importTimesheetData}
              >
                {(processingWarnings || processingFile) &&
                  <Spinner
                    style={{ height: "1.5em", verticalAlign: 'middle', float: "left" }}
                    className="animate-spin -ml-1 mr-3 h-5 w-5 "
                  />
                  ||
                  <ClipboardDocumentCheckIcon style={{ height: "1.5em", float: "left", marginRight: 5 }} />
                }
                <span>Review {filename}</span>
              </div>

              <div className="clearfix" />
            </div>
          }
        </React.Fragment>
      }

      {
        dataToSend && !processingWarnings && !processingFile && hasWarnings &&
        <div style={{ marginTop: 20 }}>
          <ImportWarnings />
        </div>
      }

      {
        dataToSend && !processingFile && !processingWarnings &&
        <a
          href="#"
          className="btn btn-success pull-right"
          onClick={(e) => {
            e.preventDefault()
            e.stopPropagation()
            sendTimesheetData()
          }}
        >
          {importStatus &&
            <Spinner
              style={{ height: "1.5em", verticalAlign: 'middle', float: "left" }}
              className="animate-spin -ml-1 mr-3 h-5 w-5 "
            />
            ||
            !hasWarnings &&
            <>
              <CheckCircleIcon style={{ height: "1.5em", float: "left", marginRight: 5 }} />
              <span>Confirm Import</span>
            </>
            ||
            <>
              <ClipboardDocumentCheckIcon style={{ height: "1.5em", float: "left", marginRight: 5 }} />
              <span>Confirm &amp; Import</span>
            </>
          }
        </a>
      }


      <div className="clearfix" />
      <TimesheetTemplateModal />
    </div>

  );
}


const mapStateToProps = (state) => {

  let hasWarnings = false

  if (state.timesheetImport.warnings && state.timesheetImport.warnings.length > 0) {
    hasWarnings = true;
  }

  if (state.timesheetImport.notFoundWarnings && state.timesheetImport.notFoundWarnings.length > 0) {
    hasWarnings = true;
  }

  if (state.timesheetImport.timesheetsOutsideOfRange && Object.keys(state.timesheetImport.timesheetsOutsideOfRange).length > 0) {
    hasWarnings = true;
  }

  const warningsGenerated = Array.isArray(state.timesheetImport.warnings)

  return {
    ...state.timesheetImport,
    leaveFrom: state.leave.from,
    leaveTo: state.leave.to,
    leave: state.leave.leave,
    leaveUpdating: state.leave.leaveUpdating,
    leaveUpdated: state.leave.leaveUpdated,

    // ignore: state.timesheetImport.ignore,
    fieldMapping: state.timesheetImport.fieldMapping,
    filename: state.timesheetImport.filename,
    processingFile: state.timesheetImport.processingFile,
    fields: state.timesheetImport.fields,
    data: state.timesheetImport.data,
    dataToSend: state.timesheetImport.dataToSend,
    warningConditions: state.timesheetImport.warningConditions,
    showMappingSettings: state.timesheetImport.showMappingSettings,
    // importWarnings: state.timesheetImport.warnings,
    hasWarnings,
    warningsGenerated,
    employeesNotFound: state.timesheetImport.employeesNotFound,
    processingWarnings: state.timesheetImport.processingWarnings,
    importStatus: state.timesheetImport.importStatus,

    importFrom: state.timesheetImport.importFrom,
    importTo: state.timesheetImport.importTo,

    deputyConnected: state.deputy.connected,
    deputyNeedsReconnection: state.deputy.needsReconnection,
    employees: state.employees.employeesWithSalary,
    employeesByReference: state.employees.employeesByReference || {},
    lastPayPeriod: state.payroll.lastPayPeriod,
    company: state?.company?.settings?.org,
    timeAttendanceIntegration: !!state.integration?.timeAttendance?.id,
    timesheetInvalidDateError: state?.timesheetImport?.invalidDate,
  }
}

const mapDispatchToProps = dispatch => ({
  timesheetImportGetMapping: () => dispatch(TIMESHEET_IMPORT_ACTIONS.timesheetImportGetMapping()),
  payrollGetLastPayPeriod: () => dispatch(PAYROLL_ACTIONS.payrollGetLastPayPeriod()),
  employeesGetListWithSalary: ({ from, to }) => dispatch(EMPLOYEE_ACTIONS.employeesGetListWithSalary({ from, to })),
  isConnectedWithDeputy: () => dispatch(DEPUTY_ACTIONS.isConnectedWithDeputy()),
  leaveGet: ({ from, to }) => dispatch(LEAVE_ACTIONS.leaveGet({ from, to, detail: 'true' })),

  setTimesheetTemplateModalOpen: () => dispatch(TIMESHEET_IMPORT_ACTIONS.setTimesheetTemplateModalOpen(true)),
  handleTimesheetPhotoImport: (file, company) => dispatch(TIMESHEET_IMPORT_ACTIONS.handleTimesheetPhotoImport({ file, company })),
  handleTimesheetImportFiles: (files) => dispatch(TIMESHEET_IMPORT_ACTIONS.handleTimesheetImportFiles(files)),
  processWarnings: () => dispatch(TIMESHEET_IMPORT_ACTIONS.processWarnings({})),
  setShowMapping: (status) => dispatch(TIMESHEET_IMPORT_ACTIONS.setShowMapping(status)),
  prepareTimesheetImportForProcessing: () => dispatch(TIMESHEET_IMPORT_ACTIONS.prepareTimesheetImportForProcessing()),
  setImportDates: ({ from, to }) => dispatch(TIMESHEET_IMPORT_ACTIONS.setImportDates({ from, to })),
  sendTimesheetData: () => dispatch(TIMESHEET_IMPORT_ACTIONS.sendTimesheetData()),
  timesheetImportInvalidDate: () => dispatch(TIMESHEET_IMPORT_ACTIONS.timesheetImportInvalidDate()),
  clearTimesheetImportData: () => dispatch(TIMESHEET_IMPORT_ACTIONS.clearTimesheetImportData()),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TimesheetImport)

